export const FASES = ["Desarrollo · Horma", "Diseño", "Prototipo", "Muestra", "Cierre", "Alta de Producto"];

export const FASE_AREA = {
  "Desarrollo · Horma": "Desarrollo · Horma",
  "Diseño": "Diseño",
  "Prototipo": "Desarrollo · Prototipo",
  "Muestra": "Desarrollo · Muestra",
  "Cierre": "Desarrollo · Cierre",
  "Alta de Producto": "Comercial · Alta de Producto",
};

export const ROLE_LABELS = {
  admin: "Administrador",
  comercial: "Comercial",
  diseno: "Diseño",
  desarrollo: "Desarrollo",
};

export const ROLE_COLORS = {
  admin: "bg-slate-900 text-white",
  comercial: "bg-amber-100 text-amber-800",
  diseno: "bg-violet-100 text-violet-800",
  desarrollo: "bg-blue-100 text-blue-800",
};

// Mapa de roles dinámico (se rellena desde el backend vía setRoleMap).
let ROLE_MAP = {
  admin: { nombre: "Administrador", color: "bg-slate-900 text-white" },
  comercial: { nombre: "Comercial", color: "bg-amber-100 text-amber-800" },
  diseno: { nombre: "Diseño", color: "bg-violet-100 text-violet-800" },
  desarrollo: { nombre: "Desarrollo", color: "bg-blue-100 text-blue-800" },
};
export function setRoleMap(list) {
  (list || []).forEach((r) => {
    ROLE_MAP[r.id] = { nombre: r.nombre, color: r.color || "bg-slate-100 text-slate-700" };
  });
}
export function labelRol(slug) {
  return ROLE_MAP[slug]?.nombre || slug || "—";
}
export function colorRol(slug) {
  return ROLE_MAP[slug]?.color || "bg-slate-100 text-slate-700";
}

// Roles que pueden editar los pasos de cada fase
export const FASE_ROLES = {
  "Desarrollo · Horma": ["desarrollo", "admin"],
  "Diseño": ["diseno", "admin"],
  "Prototipo": ["desarrollo", "admin"],
  "Muestra": ["desarrollo", "admin"],
  "Cierre": ["desarrollo", "admin"],
  "Alta de Producto": ["comercial", "admin"],
};

export const SECTION_ROLES = {
  identidad: ["admin"],
  ficha_tecnica: ["desarrollo", "admin"],
  organizacion: ["comercial", "admin"],
  comercial: ["comercial", "admin"],
  notas: ["desarrollo", "admin"],
  planeacion: ["comercial", "admin"],
};

export const MULTIMEDIA_ROLES = {
  boceto: ["diseno", "admin"],
  foto_final: ["desarrollo", "admin"],
};

export function canEditStep(role, fase) {
  return (FASE_ROLES[fase] || []).includes(role);
}
export function canEditSection(role, section) {
  return (SECTION_ROLES[section] || []).includes(role);
}
export function canEditMultimedia(role, tipo) {
  return (MULTIMEDIA_ROLES[tipo] || []).includes(role);
}

export function money(v) {
  if (v == null || v === "") return "—";
  return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(v);
}

export function fechaCorta(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" });
}

export function fechaSolo(str) {
  if (!str) return "—";
  const d = str.length <= 10 ? new Date(str + "T00:00:00") : new Date(str);
  return d.toLocaleDateString("es-MX", { day: "2-digit", month: "short", year: "numeric" });
}

export function dias(n) {
  if (n == null) return "—";
  return `${n} ${n === 1 ? "día" : "días"}`;
}

export function fechaHora(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("es-MX", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

// Eliminar modelos deshabilitado (8-oct-2026): un modelo que no se continúa se DEPURA (con motivo).
// Debe coincidir con ELIMINAR_MODELOS_HABILITADO del backend.
export const ELIMINAR_MODELOS_HABILITADO = false;
